// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1IDB9","Label":"BuildControl_Label__1i6LV","Less":"BuildControl_Less__HpmsA","More":"BuildControl_More__2Gq32"};